<template>
  <div class="index">
    <div class="index-items">
      <div class="card">
        <div class="card-title">用户反馈</div>
        <div class="card-line">
          <div class="card-line-title">购买地址</div>
          <div class="card-line-content" @click="popupCity = true">
            <span style="font-size: 14px;">{{ region }}</span>
            <img src="../assets/icon/right.png" alt="">
          </div>
          <van-popup v-model="popupCity" position="bottom">
            <van-area :area-list="areaList" @confirm="confirmArea" @cancel="popupCity = false" />
          </van-popup>
        </div>
        <div class="card-line">
          <div class="card-line-title">详细地址</div>
          <normal-input id="shopAddress" keyname="shopAddress" v-model="shopAddress" :rules="defaultRules" clearable
            :isShowIcon='false' placeholder="请输入详细地址" label="" type="" :isAutoFocus="true"
            update:modelValue="inputUpdate" @dropDownValueChange="fruitValueChange"></normal-input>
        </div>
        <div class="card-line">
          <div class="card-line-title">购买店铺</div>
          <normal-input id="shop" keyname="shop" v-model="shop" :rules="defaultRules" clearable :isShowIcon='false'
            placeholder="请输入购买店铺" label="" type="" :isAutoFocus="true" update:modelValue="inputUpdate"
            @dropDownValueChange="fruitValueChange"></normal-input>
        </div>
        <div class="card-line">
          <div class="card-line-title">联系方式</div>
          <normal-input id="mobile" keyname="mobile" v-model="mobile" :rules="mobileRules" clearable :isShowIcon='false'
            placeholder="请输入联系方式" label="" type="" :isAutoFocus="true" update:modelValue="inputUpdate"
            @dropDownValueChange="fruitValueChange"></normal-input>
        </div>
        <div class="card-line">
          <div class="card-line-title">您的姓名</div>
          <normal-input id="name" keyname="name" v-model="name" :rules="nameRules" clearable :isShowIcon='false'
            placeholder="请输入您的姓名" label="" type="" :isAutoFocus="true" update:modelValue="inputUpdate"
            @dropDownValueChange="fruitValueChange"></normal-input>
        </div>
        <!-- <div class="card-line">
          <div class="card-line-title">标签串号</div>
          <normal-input id="no" keyname="no" v-model="no" :rules="defaultRules" clearable :isShowIcon='false'
            placeholder="请输入标签串号" label="" type="" :isAutoFocus="true" update:modelValue="inputUpdate"
            @dropDownValueChange="fruitValueChange"></normal-input>
        </div> -->
        <div class="card-line">
          <div class="card-line-title">反馈类型</div>
          <div class="card-line-content" @click.stop="popupType = true">
            <span>{{ reportType }}</span>
            <img src="../assets/icon/right.png" alt="">
          </div>
          <van-popup v-model="popupType" position="bottom">
            <van-picker show-toolbar title="选择反馈类型" :columns="typeOptions" @cancel="popupType = false"
              @confirm="confirm" />
          </van-popup>
        </div>
        <div class="card-line">
          <div class="card-line-title">反馈内容</div>
          <div class="card-line-content">
            <textarea placeholder="请输入反馈内容" v-model="message"></textarea>
          </div>
        </div>
        <div class="card-line">
          <div class="card-line-title">图片附件（可选）</div>
          <div class="card-line-content">
            <div class='report-container'>
              <div class="textarea-item">
                <div class='addimage'>
                  <div v-for="(item, index) in reportAttachmentList" :key="index" style="position: relative;">
                    <img class="main-image" :src="item.attachment" @click="previewImage(index)" />
                    <img src="../assets/img/img_upload_delete.png" class="del-image" @click.stop="deleteImage(index)">
                  </div>
                  <div style="position: relative;">
                    <input type="file" style="z-index: 9999;" accept="image/*" @change="onRead">
                    <img class="main-image" src="../assets/img/img_upload_btn.png" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="index-items-logo">
        <img src="../assets/img/logo.png">
      </div>

    </div>

    <div class="index-btn">
      <button @click="submit" :style="disabledValue ? '' : 'background: #f8dda1;'"
        :disabled='!disabledValue'>提交反馈信息</button>
    </div>



    <!-- <div class='report-container'>
      <div class="input-item">
        <span>反馈类型</span>
        <span @click="popupType = true">{{ reportType }}</span>
        <van-popup v-model="popupType" position="bottom">
          <van-picker show-toolbar title="选择反馈类型" :columns="typeOptions" @cancel="popupType = false"
            @confirm="confirm" />
        </van-popup>
      </div>
      <div class="input-item">
        <span>您的姓名</span>
        <input placeholder="请输入您的姓名" v-model="name">
      </div>
      <div class="textarea-item">
        <span>图片附件（可选）</span>
        <div class='addimage'>
          <div v-for="(item, index) in reportAttachmentList" :key="index" style="position: relative;">
            <img class="main-image" :src="item.attachment" @click="previewImage(index)" />
            <img src="../assets/img/img_upload_delete.png" class="del-image" @click.stop="deleteImage(index)">
          </div>
          <div style="position: relative;">
            <input type="file" accept="image/*" @change="onRead">
            <img class="main-image" src="../assets/img/img_upload_btn.png" />
          </div>
        </div>
      </div>
      <div class="footer">
        <button @click="submit">提交反馈信息</button>
      </div>
    </div> -->

    <!-- <div class="index-logo">
      <img src="../assets/img/logo.png">
    </div> -->

  </div>


</template>

<script>
import Vue from 'vue'
import qs from 'qs'
import area from '@/util/area'
import { mapGetters } from 'vuex'

import { Area, Popup, Picker, Toast, Dialog } from 'vant'
import { ImagePreview } from 'vant'
import NormalInput from '@/components/normalInput.vue'

Vue.use(Popup).use(Area).use(Picker).use(Toast)
export default {
  name: 'Report',
  data() {
    return {
      areaList: area,
      typeOptions: [
        { text: '销售假货', key: 0 },
        { text: '窜货', key: 1 }
      ],
      popupCity: false,
      popupType: false,

      reportType: '请选择反馈类型',
      type: null,
      region: '请选择购买地址',
      shop: '',
      shopAddress: '',
      name: '',
      mobile: '',
      message: '',
      no: '',
      reportAttachmentList: [],
      mobileRules: [
        { type: 'isPhoneNumber', message: '手机号格式不对' },
      ],
      nameRules: [
        { type: 'isSpecialChar', message: '不能包含特殊字符和表情，且长度不能超过32位' },
        { type: 'isNameLength', message: '长度必须保证在1~32位', min: 1, max: 32 },
      ],
      defaultRules: [{ type: 'isEmpty', message: '请输入内容，不能为空' }],
      // ???校验
      verify: {
        shopAddress: false,
        shop: false,
        mobile: false,
        name: false,
      }
    }
  },
  created() {
  },
  computed: {
    ...mapGetters(['location', 'qrcode']),
    disabledValue() {
      return (this.verify.shopAddress && this.verify.shop && this.verify.mobile &&
        this.verify.name && this.region != '请选择购买地址' && this.reportType != '请选择反馈类型' && this.message)
    }
  },
  components: {
    NormalInput
  },
  methods: {
    submit() {
      if (this.region == '请选择购买地址') {
        return Toast('请选择购买地址')
      }
      if (!this.shop) {
        return Toast('请输入店铺名称')
      }
      if (!this.shopAddress) {
        return Toast('请输入店铺地址')
      }
      if (!this.name) {
        return Toast('请输入您的姓名')
      }
      if (!this.mobile) {
        return Toast('请输入您的手机号')
      }
      if (this.reportType == '请选择反馈类型') {
        return Toast('请选择反馈类型')
      }
      var that = this
      var params = {
        shop: this.shop,
        address: this.region + '/' + this.shopAddress,
        name: this.name,
        mobile: this.mobile,
        location: this.location.address,
        latitude: this.location.latitude,
        longitude: this.location.longitude,
        province: this.location.province,
        city: this.location.city,
        district: this.location.district,
        province_code: this.location.province_code,
        city_code: this.location.city_code,
        district_code: this.location.district_code,
        message: this.message,
        type: this.type,
        attachments: []
      }
      if (this.qrcode) {
        params.qrcode = this.qrcode.id
      }
      if (this.reportAttachmentList.length) {
        for (const item of this.reportAttachmentList) {
          params.attachments.push(item.id)
        }
        params.attachments = JSON.stringify(params.attachments)
      }
      this.axios.post('/antifake/report/', qs.stringify(params)).then(function (res) {
        if (res.data) {
          Dialog.alert({
            message: '感谢您的反馈，我们会尽快核实，确认信息属实将给您5个积分的奖励'
          }).then(() => {
            that.$router.go(-1)
          })
        } else {
          Toast(res.data.msg)
        }
      }).catch(function (error) {
        console.log(error)
        Toast('提交失败')
      })
    },

    confirmArea(data) {
      this.popupCity = false
      this.region = data[0].name + ' ' + data[1].name + ' ' + data[2].name
      this.province = data[0].code
      this.city = data[1].code
      this.district = data[2].code
    },
    fruitValueChange(e, keyname) {
      this.verify[keyname] = e
    },

    confirm(value) {
      this.popupType = false
      this.reportType = value.text
      this.type = value.key
    },

    onRead(e) {
      if (this.reportAttachmentList.length > 8) {
        return Toast('最多上传9张图片')
      }
      var that = this
      var file = e.target.files[0]
      var params = new FormData()
      params.append('image', file)
      params.append('type', 'reportAttachment')
      that.axios.post('/antifake/report/attachment/', params, { headers: { 'content-type': 'multipart/form-data' } }).then(function (res) {
        if (res.data.id) {
          that.reportAttachmentList.push({ attachment: res.data.image, type: 0, id: res.data.id })
          Toast('上传成功')
        } else {
          Toast(res.data.msg)
        }
      }).catch(function (error) {
        console.log(error)
        if (error.response.msg) {
          Toast(error.data.msg)
        } else {
          Toast('上传失败')
        }
      })
    },
    previewImage(index) {
      var images = []
      for (var item of this.reportAttachmentList) {
        images.push(item.attachment)
      }
      ImagePreview({
        images: images,
        startPosition: index,
        loop: false
      })
    },
    deleteImage(index) {
      this.reportAttachmentList.splice(index, 1)
    }
  }
}
</script>

<style lang="scss" scoped>
.index {
  background: #F6F8FA;
  height: 233px;
  background: linear-gradient(180deg, #FFE09A 0%, #F6F8FA 100%);

  &-items {
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-left: 15px;
    margin-right: 15px;

    &-logo {
      margin-top: 16px;
      margin-bottom: 100px;
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 30px;
      right: 16px;
      left: 16px;
      bottom: 20px;
      padding-bottom: 20px;

      img {
        width: 120px;
        height: 30px;
      }
    }
  }

  .card {
    background: #ffffff;
    border-radius: 16px;
    padding: 16px;
    margin-top: 16px;
    // display: flex;
    // flex-direction: column;

    &-title {
      font-size: 16px;
      font-weight: bold;
      color: #111827;
    }

    &-line {
      display: flex;
      flex-direction: column;
      gap: 12px;

      &.row {
        flex-direction: row;
        justify-content: space-between;
      }

      &-title {
        margin-top: 16px;
        font-size: 14px;
        font-weight: bold;
        color: #111827;
      }

      &-tips {
        font-size: 12px;
        font-weight: 400;
        color: #A0AEC0;
      }

      &-content {
        flex: 1;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 14px 16px;
        background: #f6f8fa;
        border-radius: 12px;

        span {
          font-size: 14px;
          color: #8b97a6;
          font-weight: 400;
        }

        textarea {
          width: 100%;
          padding: 16px;
          border-style: none;
          background: #f6f8fa;
          height: 195px;
        }

        input {
          flex: 1;
          font-size: 14px;
        }

        img {
          width: 16px;
          height: 16px;
          transform: rotate(90deg);
        }
      }

      &-btn {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 48px;
        height: 48px;
        font-size: 16px;
        font-weight: bold;
        color: #ffffff;
        background: #0caf60;
        box-shadow: 0px 4px 8px 0px rgba(0, 88, 45, 0.2);
        border-radius: 12px;
      }
    }
  }


  &-btn {
    position: fixed;
    bottom: 35px;
    left: 0;
    right: 0;
padding-bottom: 50px;

    /* 兼容 iOS >= 11.2 */
    margin-left: 15px;
    margin-right: 15px;

    button {
      width: 100%;
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      padding-top: 15px;
      padding-bottom: 15px;
      background: #FAC859;
      box-shadow: 0px 4px 8px 0px rgba(250, 200, 89, 0.11);
      border-radius: 12px;
      font-weight: 500;
      font-size: 16px;
      color: #FFFFFF;
      border-style: none
    }
  }

  &-logo {
    position: absolute;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 30px;
    right: 16px;
    left: 16px;
    bottom: 20px;
    padding-bottom: 20px;

    img {
      width: 120px;
      height: 30px;
    }
  }

}

/deep/ .login-input {
  font-size: 14px !important;
  color: #111827 !important;
  background: #F6F8FA !important;
  border-radius: 12px;
  z-index: 0;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  border: none !important;

  input {
    background-color: transparent !important;
  }
}


.report-container {
  padding-bottom: 65px;

  .input-item {
    height: 44px;
    padding: 0 20px;
    background-color: #ffffff;
    margin-bottom: 1px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    span {
      color: #4a4a4a;
      font-size: 14px;
      font-weight: 400;
    }

    input {
      width: 250px;
      color: #4a4a4a;
      font-size: 14px;
      font-weight: 400;
      text-align: right;
    }
  }

  .textarea-item {
    // background-color: #ffffff;
    line-height: 44px;
    margin-bottom: 1px;

    span {
      color: #4a4a4a;
      font-size: 14px;
      font-weight: 400;
      margin-left: 20px;
    }

    textarea {
      width: 90%;
      height: 80px;
      padding: 5px;
      font-size: 14px;
      border-color: #ffffff;
      color: #4a4a4a;
      resize: none;
      display: block;
      margin: 0 auto;
    }

    .addimage {
      // margin-left: 20px;
      display: flex;
      flex-wrap: wrap;

      .add {
        line-height: 0px;
        display: inline-block;
        margin: 28px 15px;
        font-size: 40px;
        color: #dddddd;
      }

      input {
        width: 60px;
        height: 60px;
        position: absolute;
        opacity: 0;
      }

      .main-image {
        width: 60px;
        height: 60px;
        margin: 0 8px 8px 0;
      }

      .del-image {
        width: 25px;
        height: 25px;
        position: absolute;
        top: 0;
        right: 6px;
      }
    }
  }

  .footer {
    width: 100%;
    height: 60px;
    position: fixed;
    bottom: 0;
    background-color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;

    button {
      width: 175px;
      height: 45px;
      border-radius: 5px;
      background-color: #5e5ef6;
      color: #ffffff;
      font-size: 16px;
      font-weight: 400;
      border: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/report.vue